import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'locales/i18n';

import { router } from 'routes';
import { ANTD_CONFIG } from 'config/antd';
import { initGA } from 'services/tracking/gaTracking';
import 'styles/global.scss';
import 'react-calendar-timeline/lib/Timeline.css';
import 'react-tooltip/dist/react-tooltip.css';
import 'ag-grid-community/styles/ag-grid.css'; // Mandatory CSS required by the grid
import 'ag-grid-community/styles/ag-theme-quartz.css'; // Optional Theme applied to the grid
import { PermissionProvider } from 'AuthorizePermission';

import { persistQueryClient } from '@tanstack/react-query-persist-client';
import QUERY_KEYS from './services/api/queryKeys';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { ONE_DAY_IN_MS } from './constants/time';

initGA();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 0,
      refetchOnMount: false,
      refetchOnWindowFocus: true
    }
  }
});

const persister = createSyncStoragePersister({
  storage: window.localStorage
});

persistQueryClient({
  queryClient,
  persister,
  maxAge: ONE_DAY_IN_MS, // 24h
  dehydrateOptions: {
    shouldDehydrateQuery: query => {
      const queryKeysToPersist = [
        QUERY_KEYS.GET_COUNTRIES,
        QUERY_KEYS.GET_TRAVEL_AGENCIES,
        QUERY_KEYS.GET_SOURCES,
        QUERY_KEYS.GET_COMPANIES
      ];
      return queryKeysToPersist.includes(query.queryKey[0] as QUERY_KEYS);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.Fragment>
    <QueryClientProvider client={queryClient}>
      <PermissionProvider>
        <ConfigProvider theme={ANTD_CONFIG}>
          <RouterProvider router={router} />
        </ConfigProvider>
      </PermissionProvider>
    </QueryClientProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
